import { withAuthenticationRequired } from "@auth0/auth0-react";
import { store } from "../store";
import { useTranslation } from "react-i18next";
import { Grid, Paper, Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import BrandsTable from "../components/tables/Brands";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Business, Store, Home } from "@mui/icons-material";

function Brands(props) {
  const { t } = useTranslation("common");

  const userDB = useSelector((state) => state.userDB);
  const brands = useSelector((state) => state.brands);
  const establishments = useSelector((state) => state.establishments);

  useEffect(() => {
    store.dispatch({ type: "pageTitle/update", payload: t("common.brands") });
    let pageActions = [];

    if (userDB && userDB.admin) {
      pageActions = [
        {
          name: t("common.add_new", { name: t("common.brand") }),
          icon: "Add",
          url: "/add/brand",
        },
      ];
    }

    store.dispatch({ type: "pageActions/update", payload: pageActions });
  }, [t, userDB]);

  // Calcul des statistiques
  const totalBrands = brands?.length || 0;
  const totalEstablishments = establishments?.length || 0;

  // Compter les établissements par enseigne
  const brandsWithEstablishments = brands?.filter(brand =>
    establishments?.some(est => est.brand_id === brand.id)
  ).length || 0;

  const statsCards = [
    { title: t("common.total"), value: totalBrands, icon: Business, color: "#78a882" },
    { title: t("common.establishments"), value: totalEstablishments, icon: Store, color: "#6b9dad" },
    { title: t("common.with_establishments") || "Avec établissements", value: brandsWithEstablishments, icon: Home, color: "#c4a574" },
  ];

  return (
    <Grid container spacing={2}>
      {/* Cartes KPI */}
      <Grid item xs={12}>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2 }}>
          {statsCards.map((card, index) => (
            <Paper
              key={index}
              sx={{
                p: 2,
                flex: "1 1 200px",
                minWidth: 200,
                background: alpha(card.color, 0.15),
                borderLeft: `4px solid ${card.color}`,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <card.icon sx={{ color: card.color, fontSize: 32 }} />
                <Box>
                  <Typography variant="h4" sx={{ color: card.color, fontWeight: "bold" }}>
                    {card.value}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {card.title}
                  </Typography>
                </Box>
              </Box>
            </Paper>
          ))}
        </Box>
      </Grid>

      {/* Tableau */}
      <Grid item xs={12}>
        <BrandsTable />
      </Grid>
    </Grid>
  );
}

export default withAuthenticationRequired(Brands);
